import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
  SupplierAdvance, SupplierAdvanceAgeing, SupplierAdvanceCreateDTO, SupplierAdvancePage,
} from '../interfaces/procurement/supplierAdvance.interface';

export const SupplierAdvanceService = {
  create: async (dto: SupplierAdvanceCreateDTO): Promise<SupplierAdvance> =>
    (await axios.post(ENDPOINTS.SUPPLIER_ADVANCE.CREATE, dto)).data,
  listByInstitution: async (page = 0, size = 10): Promise<SupplierAdvancePage> => {
    const institutionId = AuthService.getSelectedInstitution()!!;
    return (await axios.get(`${ENDPOINTS.SUPPLIER_ADVANCE.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`)).data;
  },
  // The caller's time zone travels in the global X-Timezone header (set by AuthContext).
  ageing: async (): Promise<SupplierAdvanceAgeing> => {
    const institutionId = AuthService.getSelectedInstitution()!!;
    return (await axios.get(ENDPOINTS.SUPPLIER_ADVANCE.AGEING(institutionId), {
      params: { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone },
    })).data;
  },
  listBySupplier: async (supplierId: string): Promise<SupplierAdvance[]> =>
    (await axios.get(ENDPOINTS.SUPPLIER_ADVANCE.LIST_BY_SUPPLIER(supplierId))).data,
  listByPurchaseOrder: async (poId: string): Promise<SupplierAdvance[]> =>
    (await axios.get(ENDPOINTS.SUPPLIER_ADVANCE.LIST_BY_PO(poId))).data,
  getById: async (id: string): Promise<SupplierAdvance> =>
    (await axios.get(ENDPOINTS.SUPPLIER_ADVANCE.GET_BY_ID(id))).data,
  reverse: async (id: string): Promise<SupplierAdvance> =>
    (await axios.post(ENDPOINTS.SUPPLIER_ADVANCE.REVERSE(id))).data,
};
